import React from "react";
import Badge from "@mui/material/Badge";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import Grid from "@mui/material/Grid2";
import { Avatar as BaseAvatar } from "../Avatar";
import { useTheme } from "@mui/material";
type Props = {
  name: string;
};

export function Avatar({ name }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      badgeContent={
        <Grid
          container={true}
          bgcolor={isDarkMode ? "common.black" : "common.white"}
          borderRadius="100%"
          width="13px"
          height="13px"
          alignItems="center"
          justifyContent="center"
        >
          <AlternateEmailIcon color="primary" sx={{ fontSize: "12px" }} />
        </Grid>
      }
    >
      <BaseAvatar name={name} size="large" />
    </Badge>
  );
}
